module.exports = __webpack_public_path__ + "static/media/hellboy-profile.e48638e3.jpg";